import { useEffect, useRef, useState } from "react";
import PUB from "@/data/pub.json";
import { api, errMsg } from "@/lib/api";

const MP = PUB.map;
const KEY = "o11_pasaporte";
const pick = (a) => a[Math.floor(Math.random() * a.length)];
const loadPP = () => { try { return JSON.parse(localStorage.getItem(KEY)) || { done: {}, resp: {} }; } catch (e) { return { done: {}, resp: {} }; } };

const Jenga = () => {
  const [hidden, setHidden] = useState({});
  const [q, setQ] = useState(null);
  return (
    <>
      <p className="note">Toca un bloque del Jenga 11:11 para sacar una pregunta:</p>
      <div className="jenga" data-testid="jenga">
        {MP.decks.flatMap((d, j) => [0, 1, 2].map((x) => {
          const id = `${j}-${x}`;
          return <button key={id} className="blk" style={{ background: d.c, visibility: hidden[id] ? "hidden" : "visible" }} aria-label={d.n} onClick={() => { setHidden({ ...hidden, [id]: 1 }); setQ({ d, t: pick(d.q) }); }} data-testid={`jenga-blk-${id}`} />;
        }))}
      </div>
      {q && <div className="qcard" style={{ borderLeft: `8px solid ${q.d.c}` }} data-testid="jenga-question">{q.t}</div>}
    </>
  );
};

const Escalera = () => {
  const [q, setQ] = useState(null);
  const n = MP.decks.length;
  return (
    <>
      <p className="note">Sube la escalera: toca cada peldaño, lee la pregunta y respóndela en tu mente o en voz alta.</p>
      <div className="stairs" data-testid="escalera">
        {MP.decks.slice().reverse().map((d, j) => (
          <button key={d.n} className="stair" style={{ background: d.c, marginLeft: `${(n - 1 - j) * 6}%` }} onClick={() => setQ({ d, t: pick(d.q), f: d.f.length ? pick(d.f) : "" })} data-testid={`stair-${n - 1 - j}`}>{d.n}</button>
        ))}
      </div>
      {q && <div className="qcard" style={{ borderLeft: `8px solid ${q.d.c}` }} data-testid="escalera-question"><small>{q.d.n}</small><br />{q.t}{q.f && <><br /><i style={{ fontWeight: 500 }}>“{q.f}”</i></>}</div>}
    </>
  );
};

const Estacion = ({ i, pp, onSave }) => {
  const s = MP.est[i];
  const [r, setR] = useState(pp.resp[i] || {});
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const datos = Object.fromEntries(s.tareas.map((t) => [t[0], (r[t[0]] || "").trim()]));
    try {
      await api.post("/participaciones", { ficha: "pasaporte", nombre: `Pasaporte · ${s.n}`, datos });
      onSave(i, datos);
    } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };
  return (
    <div className="stationbox" data-testid="station-box">
      <div><img src={s.img} alt="" /></div>
      <div>
        <small style={{ color: "var(--sol-l)", fontWeight: 800 }}>ESTACIÓN {i + 1}</small>
        <h3 style={{ margin: "4px 0" }} data-testid="station-title">{s.n}</h3>
        <p style={{ margin: 0 }}><b>Tema:</b> {s.tema}</p>
        <div className="msg">“{s.msg}”</div>
        <p><b>Actividad:</b> {s.act}</p>
        {s.jenga && <Jenga />}
        {s.escalera && <Escalera />}
        <form className="frm" onSubmit={submit} data-testid="station-form">
          <b>Tarea de crecimiento personal</b>
          {s.tareas.map((t) => (
            <label key={t[0]}>{t[1]}<textarea value={r[t[0]] || ""} maxLength={500} onChange={(e) => setR({ ...r, [t[0]]: e.target.value })} data-testid={`station-tarea-${t[0]}`} /></label>
          ))}
          <button className="btn btn-sol" type="submit" disabled={busy} data-testid="station-submit-btn">{pp.done[i] ? "Actualizar" : "Sellar mi pasaporte"}</button>
          {err && <p className="err" data-testid="station-error">{err}</p>}
        </form>
      </div>
    </div>
  );
};

const Pasaporte = ({ pp }) => (
  <div className="passport" data-testid="passport">
    <b>Mi pasaporte Once y Once</b>
    <div className="stamps">
      {MP.est.map((s, i) => <div key={s.n} className={"stamp" + (pp.done[i] ? " on" : "")} data-testid={`stamp-${i}`}>{pp.done[i] ? <>11:11<br />✓</> : `Estación ${i + 1}`}</div>)}
      {Object.keys(pp.done).length === 4 && <div className="stamp on" style={{ width: "auto", padding: "0 14px", borderRadius: 999 }} data-testid="stamp-final">#SoyOnceyOnce</div>}
    </div>
    <p className="note" style={{ color: "#fff", margin: 0 }}>Participa, sella cada estación y completa tu tarea de crecimiento personal. Al terminar las 4 recibes tu sello #SoyOnceyOnce.</p>
  </div>
);

export const Mapa = () => {
  const [pp, setPP] = useState(loadPP);
  const [cur, setCur] = useState(0);
  const vid = useRef(null);
  const route = useRef(null);

  useEffect(() => {
    const v = vid.current;
    v.muted = true;
    if (!("IntersectionObserver" in window)) return undefined;
    const io = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) v.play().catch(() => {}); else v.pause(); }));
    io.observe(v);
    return () => io.disconnect();
  }, []);

  const save = (i, datos) => {
    const n = { done: { ...pp.done, [i]: true }, resp: { ...pp.resp, [i]: datos } };
    setPP(n);
    try { localStorage.setItem(KEY, JSON.stringify(n)); } catch (e) { /* noop */ }
    setCur(i < 3 ? i + 1 : i);
    route.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="mapa" data-testid="mapa-section">
      <div className="wrap">
        <div className="head reveal"><h2>Mapa del viaje hacia el interior</h2><p className="lead" style={{ margin: 0 }}>Pasaporte de bienestar Once y Once: cuatro estaciones para reconectar contigo, descubrir tu arte y manifestar tu propósito.</p></div>
        <div className="mapvid">
          <video ref={vid} muted loop playsInline preload="metadata" poster={MP.img} data-lazyplay="1" data-testid="map-video"><source src={MP.video} type="video/mp4" /></video>
          <p data-testid="map-intro">{MP.intro}</p>
        </div>
        <div className="route" ref={route} data-testid="map-route">
          {MP.est.map((s, i) => (
            <button key={s.n} className={"rst" + (pp.done[i] ? " done" : "")} aria-pressed={i === cur} onClick={() => setCur(i)} data-testid={`route-btn-${i}`}><i>{pp.done[i] ? "✓" : i + 1}</i>{s.n}</button>
          ))}
        </div>
        <Estacion key={cur} i={cur} pp={pp} onSave={save} />
        <Pasaporte pp={pp} />
      </div>
    </section>
  );
};

export const Fundador = () => (
  <section style={{ paddingTop: 0 }} data-testid="fundador-section">
    <div className="wrap">
      <div className="founder reveal">
        <div className="mono" aria-hidden="true">BA</div>
        <div>
          <blockquote data-testid="fundador-cita">“El deporte forma campeones cuando también forma personas.”</blockquote>
          <b>Bashir Abuchaibe</b><br />
          <small>Psicólogo del Deporte y el Alto Desempeño · Fundador · <a href="https://www.instagram.com/psi.bashir/" target="_blank" rel="noopener noreferrer" data-testid="fundador-instagram-link">@psi.bashir</a></small>
        </div>
      </div>
    </div>
  </section>
);
